<template>
	<div class="content-scroll">
		<div class="content-box page">
            <el-tabs active-name="first" class="pageTitle">
				<el-tab-pane label="产品价格列表" name="first"></el-tab-pane>
			</el-tabs>
            <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus" title="新增">新增</el-button>

            <el-form ref="form" :inline="true" :model="filters" size="small">
                <el-form-item label="搜索条件" prop="company">
                    <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
                </el-form-item>
                <el-form-item label="产品价格区间" >
                  <el-form-item prop="min">
                    <el-input v-model.number="filters.minPrice" class="w50" @change="rangeValidate" />
                  </el-form-item>
                  ~
                  <el-form-item prop="max">
                    <el-input v-model.number="filters.maxPrice" class="w50" @change= "rangeValidate"/>
                  </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="primary" @click="handleExport()">导出</el-button>
                </el-form-item>
              <el-form-item>
                <el-button size="small" class="el-icon-download" type="danger" @click="handleExportTemplate()">模板下载</el-button>
              </el-form-item>

              <el-form-item>
                  <el-upload
                      ref='import'
                      :action="root + uploadUrl"
                      :show-file-list="false"
                      :on-success="importSuccess"
                      :before-upload="beforeImportFile"
                      :on-error="handleError"
                      :headers="{'username': username }">
                      <el-button size="small" type="warning">产品价格导入</el-button>
                  </el-upload>
              </el-form-item>

            </el-form>
            
            <!--列表-->
            <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
                <el-table-column prop="nbr" label="序号" width="130" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="company" label="公司名称"  align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="product" label="产品"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="standards" label="规格"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="price" label="价格"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="num" label="起订量"></el-table-column>
                <el-table-column label="操作" width="160" align="right" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.picture!=null" title="下载图片" @click="handlePicture(scope.row)" icon="el-icon-picture"></el-button>
                        <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)" icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)" icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar" style="text-align: right;">
                <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"  :page-size="filters.pageSize" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
            </div>

            <!--新增界面-->
            <el-dialog :title="saveType ? '产品价格编辑':'产品价格新增'" :visible.sync="aVisible" width="80%" :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
                <el-form :model="formData" :rules="formRules" label-width="180px" ref="formFileds" size="small">
                  <el-form-item label="产品" prop="product" class="inlineForm w450">
                    <el-input clearable v-model="formData.product"></el-input>
                  </el-form-item>
                  <el-form-item label="公司名称" prop="company" class="inlineForm w450">
                        <el-input clearable v-model="formData.company"></el-input>
                    </el-form-item>
                    <el-form-item label="价格" prop="price" class="inlineForm w450">
                        <el-input clearable v-model="formData.price"></el-input>
                    </el-form-item>
                    <el-form-item label="起订量" prop="num" class="inlineForm w450">
                        <el-input clearable v-model.number="formData.num"></el-input>
                    </el-form-item>
                    <el-form-item label="规格" prop="standards" class="inlineForm w450">
                      <el-input clearable v-model.number="formData.standards"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" prop="picture">
                      <el-upload
                          ref="upload"
                          class="upload-demo"
                          :action="root + uploadUrl"
                          :on-remove="handleRemove"
                          :on-success="handleSuccess"
                          :before-upload="beforeUpload"
                          :file-list="fileList"
                          :limit="1"
                          :headers="{'username': username }"
                          list-type="picture"
                      >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5Mb</div>
                      </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click.native="aVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)" :loading="bLoading">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'spjg',
    data() {
        let valiNumber = (rule, value, callback) => {//包含小数的数字
          let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/g;
          if (value === '') {
            callback(new Error('请输入内容'));
          } else if (!reg.test(value)) {
            callback(new Error('请输入数字，单位为元，最小到分'));
          } else {
            callback();
          }
        };
        return {
            pageUrl:'/product/price/list/page',
            updateUrl:'/product/price/saveOrUpdate',
            uploadFilePath: 'picture',
            addUrl:'/product/price/saveOrUpdate',
            deleteUrl:'/product/price/remove',
            exportUrl:'/product/price/export',
            exportTemplateUrl:'/product/price/exportTemplate',
            importUrl:'/product/price/import',

            filters:{
                pageSize: 10,
                pageIndex: 1,
                company:'',
                minPrice:null,
                maxPrice:null
            },
            
            formData:{
                company:'',
                product:'',
                price:'',
                standards:'',
                picture:'',
                num:0
            },
            formRules: {
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' } 
                ],
                product: [
                    { required: true, message: '请输入产品', trigger: 'blur' }
                ],
                price: [
                  { required: true, validator:valiNumber, trigger: "blur"},
                ],
                num: [
                  { type: 'number', message: '起订量必须为数字值', trigger: 'blur' },
                ]
            },
            fileList: [],
        }
    },
    computed:{
        ...mapGetters(['username'])
    },
    methods: {
        handlePicture(row){
          let ds = row.picture;
          let arr = ds.split('.');
          window.open(row.picture+'?attname='+row.nbr+'.'+arr[arr.length-1]);
        },
        handleForm(type, row) {
          this.aVisible = true;
          this.$nextTick(() => {
            this.$refs.formFileds.resetFields()
            this.formData.picture = ''
            if (this.$refs.upload) {
              this.$refs.upload.clearFiles()
              this.fileList = []
            }
            if (type) {
              this.saveType = 1
              this.formData.id = row.id
              this.mergeObject(this.formData, row)
              if(row.picture){
                this.fileList.push({
                  name: row.picture,
                  url: row.picture
                })
              }
            } else {
              this.saveType = 0
              delete this.formData.id
            }
          })
        },
        rangeValidate(){
          let i = 0;
          let b = false;
          if(this.filters.minPrice && this.filters.maxPrice && this.filters.minPrice>this.filters.maxPrice){
            b = true;
          }
          if(this.filters.minPrice && this.filters.maxPrice && this.filters.minPrice>this.filters.maxPrice){
            b = true;
          }
          if(b){
            i = this.filters.maxPrice;
            this.filters.maxPrice = this.filters.minPrice;
            this.filters.minPrice = i;
          }
        },
        beforeUpload(file) {
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!file.name.includes("jpg") && !file.name.includes("png") && !file.name.includes("jpeg")) {
                this.$message.warning("只能上传jpg/png文件");
                return false;
            }
            if (!isLt5M) {
                this.$message.error('上传头像图片大小不能超过 5MB!');
                return false;
            }
        }
    },
    created(){
        this.getPage()
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>